

import { useState } from "react"
import { Header } from "../../../IndexPage/Header/Header"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Footer } from "../../../Footer/Footer"


export const FORENSICAUDIT = () => {

    const [ReadMoreText, setReadMoreText] = useState(false)

    const handleReadmore = () => {
        setReadMoreText(!ReadMoreText)
    }

    return (
        <>
         <div className="container-fluid">
            <div className="row" onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="FORENSICAUDIT" />
                    <HerosectionsAll ScreenName="Forensic Audit" ScreenSearch="ForensicAudit" />
                    <div className="row p-2 p-lg-5" >

                        <div className="col-12 col-lg-12 py-3">
                            <div className="p-4 faint " style={{ position: 'relative',  textAlign: 'justify',  }}>
                                <h5 className="fw-bold gray_color">Forensic Audit</h5>

                                <p>Forensic auditing is a perfect combination of accounting, auditing and investigation. It is a thorough examination of the company’s financial statements and records which established the facts of the financial transactions and which can be used in legal proceedings. </p>

                                <p>
                                    Marine insurance deals with the highly moveable properties i.e. cargo and vessels, involving number of parties and financial institutions all over the globe. Every business sector is experiencing a surge in e-commerce, and marine insurance transactions are no different!
                                </p>

                                <p>
                                    In the competitive and fast-paced commercial world of today, it is imperative to issue customized insurance products for marine cargo for e.g. Sales Turnover Policy, Delay in Start Up Policy. Coverages under such products are "from Cradle to Grave".
                                </p>



                                {ReadMoreText && (
                                    <div>
                                        <p>
                                            In order to ascertain whether accounting transactions are compliant with various accounting, auditing, and legal standards and, ultimately to identify financial anomalies or fraud, we conduct proactive forensic audits for our clients.
                                        </p>
                                        <p>
                                            We demystify complex accounting jargons related the various types of Marine cargo and Hull & Machinery claims assisting the underwriters in making decisions about claim settlement and assisting the assured in understanding the precise claim they should demand from the underwriter which may avoid the further litigation.  Which, in the end, saves the valuable time and unnecessary expense of the legal procedure to be followed and creates a "Win-Win" situation for both sides.
                                        </p>
                                    </div>

                                )}

                                <p className="float-end read_more_btn pb-lg-3">
                                    <button className="btn button" onClick={handleReadmore}>
                                        <span>{ReadMoreText ? 'Read Less' : 'Read More'}</span>
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            </div>
        </>
    )
}



